import { Button, Form, Input, message, Select } from "antd";
import { useEffect, useState } from "react";
import PowerBIReport from "../../../components/PowerBIReport";
import ContentTitle from "../../../components/ui/ContentTitle";
import "./PowerBiTest.scss";

//Permission usage
import { Dispatch, SetStateAction } from "react";
import { useReactiveVar } from "@apollo/client";
import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { __currentUser__ } from "../../../graphql/policies";
import { ServiceTypes } from "../../../types/types";
import { renderAntDMessageConfig } from "../../../utils/renderAntDMessageConfig";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import requiredRule from "../../../utils/formRules/requiredRule";

interface PowerBiTestProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const PowerBiTest = ({
  setSelectedService,
  setSelectSubItem,
}: PowerBiTestProps) => {
  const [info, setInfo] = useState({
    role: "KR",
    groupId: "90d2e0c9-d2b5-43ba-868d-ccc527ac8fb6",
    reportId: "fbc6d601-8fe8-4b4b-8656-46ecfc978e3d",
    datasetId: "760d1bb1-1c7b-45ee-8c99-9eeb32322b8e",
  });
  const [showReport, setShowReport] = useState(false);

  const [form] = Form.useForm();

  const currentUser = useReactiveVar(__currentUser__);
  const {
    data: userPrograms,
    loading: userProgramsLoading,
    error: userProgramsError,
  } = useGetUserProgramsByServiceQuery({
    variables: {
      userId: parseInt(renderDecodedId(currentUser?.id)),
      serviceId: 2,
    },
  });

  const onSubmit = () => {
    const { role, groupId, reportId, datasetId } = form.getFieldsValue();
    setInfo({
      role: role,
      groupId: groupId,
      reportId: reportId,
      datasetId: datasetId,
    });
    setShowReport(true);
  };

  useEffect(() => {
    setSelectedService(ServiceTypes.CLUB_APP);
    setSelectSubItem("Power BI Test");

    form.setFieldsValue({
      role: "KR",
      groupId: "90d2e0c9-d2b5-43ba-868d-ccc527ac8fb6",
      reportId: "fbc6d601-8fe8-4b4b-8656-46ecfc978e3d",
      datasetId: "760d1bb1-1c7b-45ee-8c99-9eeb32322b8e",
    });
  }, []);

  if (userProgramsError) {
    message.error(
      renderAntDMessageConfig(
        "Something went wrong. Please contact your system administrator."
      )
    );
  }

  if (userProgramsLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Power BI Test"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <div id="powerBiTestWrapper">
      <ContentTitle title="Power BI Test" />
      <div className="content-container">
        <div className="flex">
          <p className="title">User O365 account:</p>
          <p className="content ml-5">{currentUser?.userEmail}</p>
        </div>
        <div className="flex mt-3">
          <p className="title">RLS Group Account: </p>
          <p className="content ml-4">
            {currentUser
              ? currentUser?.afUserMarkets?.length === 3
                ? "Global"
                : currentUser.afUserMarkets?.map((i) => i?.market).join(", ")
              : ""}
          </p>
        </div>
        <Form form={form} className="mt-5 w-2/5">
          <Form.Item
            label="Role"
            rules={[requiredRule]}
            name="role"
            className="w-1/3"
          >
            <Input value={info.role} />
          </Form.Item>
          <Form.Item label="Group ID" rules={[requiredRule]} name="groupId">
            <Input value={info.groupId} />
          </Form.Item>
          <Form.Item label="Report ID" rules={[requiredRule]} name="reportId">
            <Input value={info.reportId} />
          </Form.Item>
          <Form.Item label="Dataset ID" rules={[requiredRule]} name="datasetId">
            <Input value={info.datasetId} />
          </Form.Item>
          <Button type="primary" onClick={onSubmit}>
            Submit
          </Button>
        </Form>
        {showReport && (
          <div style={{ height: "1000px", marginTop: "24px" }}>
            <PowerBIReport
              isMobile={false}
              role={info.role}
              groupId={info.groupId}
              propsReportId={info.reportId}
              datasetId={info.datasetId}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PowerBiTest;
